export const COGNITO_USER_POOL_DOMAIN = 'federate-odi-dashboard.auth.us-west-2.amazoncognito.com'
export const COGNITO_USER_POOL_ID = 'us-west-2_FX2Hb6NQn'
export const COGNITO_USER_POOL_CLIENT_ID = '1odngoa4559k44f1h3qmi5prc2'
export const COGNITO_IDENTITY_POOL_ID = 'us-west-2:3a921eec-3e82-4a87-bdf3-ac56f8721432'
export const COGNITO_IDENTITY_POOL_DOMAIN = 'cognito-idp.us-west-2.amazonaws.com/us-west-2_FX2Hb6NQn'
export const AWS_REGION = 'us-west-2'
export const DYNAMODB_JOBS_TABLE_NAME = 'ft-ar-loadjob-history'
export const DYNAMODB_JOBS_TABLE_MONTH_JOBSTARTTIME_INDEX_NAME = 'month-jobStartTime-index'
